<template>
  <Profile :view-name="$route.name" :user-details="userDetails" :showEditMode="true"></Profile>
</template>

<script>
import Profile from '@/components/Profile'
import { mapGetters } from 'vuex'
export default {
  components: {
    Profile
  },
  data () {
    return {
      userDetails: null
    }
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getProfileDetails'
    ])
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    console.log('this is edit my profile template')
    this.userDetails = this.getProfileDetails
  },
  watch: {
    getProfileDetails (newDetails, oldDetails) {
      if (newDetails !== null && newDetails !== 'user data not available') {
        this.userDetails = this.getProfileDetails
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/EditMyDetails.vue